import { useSelectedOrgId } from "@fero/hooks";
import { useQuery } from "@tanstack/react-query";
import { assertNotUndefined } from "utils/hx/util/types";
import { useAppService } from "../../use-app-service";
import { storageLocationKeys } from "../query-keys";

interface GetStorageLocationsQueryParams {
  enabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSuccess?: (data?: any) => void;
}

export const useGetStorageLocationsQuery = (
  params: GetStorageLocationsQueryParams = {},
) => {
  const { enabled = true, onSuccess } = params;
  const service = useAppService();
  const organisationId = assertNotUndefined(useSelectedOrgId());

  return useQuery({
    queryKey: storageLocationKeys.getStorageLocations(organisationId),
    queryFn: () =>
      service.getStorageLocations({
        orgId: organisationId,
        selector: { kind: "associated" },
      }),
    enabled,
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
  });
};
